import React, { useState, useEffect, useContext } from 'react'
import { ViewHeader, API } from '@enkla-gui'
import { UserContext } from '@/App'

export default function Greeting({ greeting = false }) {
	const { user } = useContext(UserContext)
	const [notifications, setNotifications] = useState({})
	useEffect(() => {
		API.get('api/auth/notifications').then(notifications => setNotifications(notifications))
	}, [])
	return (
		<div class='component_Greeting'>
			<ViewHeader
				loading={Object.keys(user).length === 0}
				documentTitle='Enkla Fastigheter'
				title={
					<div class='col'>
						<span class='text'>
							<span class='d-inline-block me-2'>👋</span>
							Hej, {user?.name}!
						</span>
					</div>
				}
				subtitle={greeting ? greeting : notifications.unread ? `Du har olästa notifikationer, läs dem uppe till höger.` : `Välkommen till Enkla Fastigheter.`}
			/>
		</div>
	)
}
